var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.changeForm,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "变更类型", prop: "changeType" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.changeForm.changeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.changeForm, "changeType", $$v)
                    },
                    expression: "changeForm.changeType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("变更")]),
                  _c("el-radio", { attrs: { label: "2" } }, [_vm._v("新增")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "选中单据", prop: "changeContent" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                },
                model: {
                  value: _vm.changeForm.changeContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.changeForm, "changeContent", $$v)
                  },
                  expression: "changeForm.changeContent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog-footer",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formRef")
                },
              },
            },
            [_vm._v("确定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("formRef")
                },
              },
            },
            [_vm._v("重置")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }